var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderWithPapersYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88676 7.70282L13.797 3.96827H11.5621L8.18042 1.08648C8.03341 0.939467 7.82758 0.88065 7.62169 0.88065H2.06396C1.56403 0.88065 1.1818 1.26294 1.1818 1.7628V7.70282H5.88676Z",
    fill: "#CC9310"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4125 7.70282H26.8238V4.85042C26.8238 4.3505 26.4415 3.96827 25.9417 3.96827H22.6482L24.4125 7.70282Z",
    fill: "#CC9310"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5601 1.29232C21.3248 0.792395 20.7073 0.557181 20.178 0.821832L5.23983 7.87927H24.6477L21.5601 1.29232Z",
    fill: "#D4E1F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7648 7.82045C27.5883 7.644 27.3531 7.5558 27.1178 7.5558H0.887773C0.652502 7.5558 0.417288 7.644 0.240835 7.82045C0.0643824 7.99691 -0.0238159 8.23212 0.00556481 8.46739L0.887716 24.4642C0.917097 24.9347 1.29938 25.2876 1.76987 25.2876H26.2356C26.7061 25.2876 27.0884 24.9347 27.1178 24.4642L28 8.46739C28 8.23212 27.9118 7.99685 27.7648 7.82045Z",
    fill: "#FFB100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderWithPapersYellow);
export default __webpack_public_path__ + "static/media/folder-with-papers--yellow.e63b8be55dfb9bfbf8d30400cca8f584.svg";
export { ForwardRef as ReactComponent };